import { getApiKey } from "../../utils/apiKey";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { apiCall_domain } from "../api";
import Header from "../header";
import axios from "axios";
import BreadCrumb from "../global/BreadCrumb";
import "../../style/brands.css";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Spinner from "../Spinner/Spinner";

const Brands = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [brandName, setBrandName] = useState();
  const [priceSort, setPriceSort] = useState([
    { label: "هیچکدام", value: 6 },
    { label: "ارزان ترین", value: 2 },
    { label: "گران ترین", value: 1 },
    { label: "جدید ترین", value: 4 },
    { label: "پر فروش ترین", value: 5 },
    { label: "پر بازدید ترین", value: 3 },
  ]);
  const { brandId } = useParams();
  const [sortAnchorEl, setSortAnchorEl] = useState(null);
  const [sort, setSort] = useState();
  const sortOpen = Boolean(sortAnchorEl);
  const handleSortClick = (event) => {
    setSortAnchorEl(event.currentTarget);
  };
  const handleSortClose = () => {
    setSortAnchorEl(null);
  };

  useEffect(() => {
    setLoading(true);
    const headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    axios
      .post(
        `${apiCall_domain}/customer/categories/3/products?brand_id=${brandId}&${
          sort ? sort : ""
        }`,
        {},
        {
          headers: headers,
        },
      )
      .then((res) => {
        setProducts(res.data.products.data);
        setBrandName(res.data.data.brand.name);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [sort]);
  return (
    <div className="brands">
      <Header showSearchBar={true} title={"برند"} />
      {+brandId === 39 ? (
        <div className="trazanoContainer">
          <img src="/public/assets/img/trazano/banner.svg" />
          <div className="trazanoBody">
            <div>
              <video
                src="/public/assets/videos/trazano.mp4"
                controls
                width="100%"
                height="100%"
              />
              <h3>تایر ترازانو</h3>
              <p>
                شرکت تولید کننده لاستیک خودروهای سواری و سنگین ترازانو (Trazano)
                از زیر مجموعه های کمپانی بزرگ ZC Rubber است که در سال 1958
                میلادی در کشور چین شروع به فعالیت کرده است. این کمپانی در بین
                تولیید کنندهگان لاستیک در کشور چین دارای رتبه اول می‌باشد.
                لاستیک های برند معتبر ترازانو باتوجه به کیفیت ، دوام عمر بالا
                قیمت های مقرون به صرفه دارند. مواد اولیه تمام تایرها درجه یک و
                با کیفیت بوده و به کمک تکنولوژی های پیشرفته روز دنیا تولید و
                عرضه می‌شود.
              </p>
            </div>
            <div>
              <img src="/public/assets/img/trazano/background.svg" />
              <ul>
                <li>دلایل اصلی رضایت مشتریان عبارتند از: </li>
                <li>1. طول عمر بالای لاستیک</li>
                <li>
                  2. فرمانپذیری خوب در جاده های مختلف مثل جاده مرطوب و خاکی و
                  ...
                </li>
                <li>3. دارای ترمزگیری مطلوب در تمامی سطوح</li>
                <li>4. استفاده از فناوری سیلیکا (silica) در ساخت لاستیک</li>
                <li>5. رانندگی بی صدا</li>
                <li>
                  6. عملکرد قابل توجه لاستیک در مقیاس چسبندگی به دلیل ترکیب ویژه
                  ساخت لاستیک
                </li>
                <li>
                  7. ساختار لاستیک بهبود یافته در مقایسه با رقبا جهت افزایش دوام
                  و راحتی سرنشینان
                </li>
                <li>9. طرح آج مرغوب</li>
                <li>10. قیمت مناسب و مقرون به صرفه</li>
              </ul>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
      <div className="brandsContainer">
        <div className="brandsHeader">
          <div className="headerTop">
            <BreadCrumb
              routes={[
                { link: "/homePage", name: "فروشگاه اینترنتی کاچار" },
                { link: `/brands/${brandId}`, name: brandName },
              ]}
            />
            {/* <i className="icon-filters" /> */}
          </div>
          <div className="headerBot">
            <div className="count">
              نتایج: <span>{products.length}</span>مورد
            </div>
            <div className="filter">
              <Button
                id="basic-button"
                aria-controls={sortOpen ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={sortOpen ? "true" : undefined}
                onClick={handleSortClick}
              >
                <div className="filterBtn">
                  <i className="icon-order" />
                  <span>بر اساس </span>
                  <i className="icon-chevron-down" />
                </div>
              </Button>
              <Menu
                id="basic-menu"
                anchorEl={sortAnchorEl}
                open={sortOpen}
                onClose={handleSortClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                {priceSort.map((range, index) => (
                  <MenuItem
                    value={range}
                    key={index}
                    onClick={() => {
                      handleSortClose();
                      setSort(range.label);
                    }}
                  >
                    {range.label}
                  </MenuItem>
                ))}
              </Menu>
            </div>
          </div>
        </div>
        {loading ? (
          <Spinner />
        ) : (
          <div className="brandsBody">
            {products.map((product) => (
              <Link to={`/product/${product.id}`} className="productCard">
                <img src={product.image} />
                <div className="productContent">
                  <span className="productName">{product.name}</span>
                  {product.stock !== 0 ? (
                    <>
                      <div className="productPriceSale">
                        <span>%{product.price_percent}</span>
                        <span> {product.min_price.toLocaleString()} تومان</span>
                      </div>
                      <span className="productOldPrice">
                        {product.old_price.toLocaleString()}
                      </span>
                    </>
                  ) : (
                    <span className="noStock">نامجود</span>
                  )}
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Brands;
